import { FC } from 'react';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { CasinoAbTests } from './casinoAbTests/CasinoAbTests';
import { CasinoAds } from './casinoAds/CasinoAds';
import { CasinoAdsTab } from './constants';

import css from './CasinoAdsPage.module.css';

import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { useTabs } from 'v2/hooks/useTabs';

export const CasinoAdsPage: FC = () => {
  const { activeTab, onTabChange } = useTabs<CasinoAdsTab>(CasinoAdsTab.CASINO);

  return (
    <PageLayout className={css.casinoAdsPage} overflow="hidden">
      <PageTitle>Casino Ads Settings</PageTitle>

      <Tabs value={activeTab} onChange={(_, v) => onTabChange(v)}>
        <Tab value={CasinoAdsTab.CASINO} label="Casino Ads" />
        <Tab value={CasinoAdsTab.AB_TEST} label="Casino AB Tests" />
      </Tabs>

      <div className={css.casinoAdsPageContent}>
        {activeTab === CasinoAdsTab.CASINO && <CasinoAds />}
        {activeTab === CasinoAdsTab.AB_TEST && <CasinoAbTests />}
      </div>
    </PageLayout>
  );
};
